module.exports = __webpack_public_path__ + "img/right-arrow.c9bb78b6.svg";